
<template>
  <cdmpending-component>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>CDM Pending</strong>
          
          </div>

           <div id="overlay" >
             <div class="loader"></div>
           </div>
          <!-- Filter  -->
      <b-row>
      <b-col md="12">
        <b-col md="12">  
        <b-row class="form-group">    
                <b-col sm="3" >
                 
              <b-form-group label="DeliveryAgent">
                 <!-- <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select> -->
                  <v-select  v-model="deliveryagentid" :options="agentmaster" placeholder="Select Delivery Agent" @input="selectdeliveryagent(deliveryagentid)"  name="deliveryagentid">
                  </v-select>
               </b-form-group>
                </b-col> 
                <b-col sm="3">
                         
                <b-form-group label="From Date"   >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>

              </b-col>
               <b-col sm="3">
               
                <b-form-group label="To Date"   >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>

              </b-col>
              <b-col sm="2" >     
               <b-button type="submit" size="md" variant="primary" @click="cdmPendinglist()" style="margin-top: 19%;"> Search</b-button>
              </b-col>
            </b-row>
            </b-col>
          </b-col>     
        </b-row>

         <!-- Filter End -->
   
         <!-- Pending Listing   -->
           <b-col sm="12" class="text-right">
            
            <b-button v-if="totalRows>0" @click="downloadCSV(Pending)" type="submit" style="margin-right: 10px;margin-bottom:5px;" variant="primary" size="md" >Download </b-button>

               <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
              </b-col> 
          <!-- <b-col sm="12"> -->
       <b-col sm="12">
             <!-- <b-col sm="12"> -->
            <b-table  show-empty stacked="md" :busy="isBusy" :items="pendingitems" :fields="fields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered" >
               
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>


            <template slot="rider_name" slot-scope="row">
              <span>{{row.item.rider_name}} - {{row.item.deliveryagentmasterid}} </span>
            </template>
            
            <template slot="created_by" slot-scope="row" >
              <div class="approved_block">
                {{row.item.created_by}}
              </div>
            </template>
            <template slot="receiptno" slot-scope="row">
               <div class="cdm_table">
                {{row.item.receiptno}}
             
            <span  v-if="row.item.receipturl !='undefined' &&row.item.receipturl !=null && row.item.receipturl !=''"  data-toggle="tooltip"   @click="reciptImagemodal(row.item)"> 
               <i class="fa fa-file-image-o" aria-hidden="true" data-toggle="tooltip" title="View Image" style="color:  #20a8d8;float:right;cursor:pointer "></i></span>

                   
                 
              </div>

            </template>
             <template slot="actions" slot-scope="row">
                  <span   style="cursor:pointer;">
                    <span data-toggle="tooltip" title="Approve">
                    <span  @click="approveconfirmation(row.item)" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Approve</span>
                  </span>
                  <span  data-toggle="tooltip" title="Reject"> 
                    <span @click="rejectconfirmation(row.item,'Reject')" class="badge badge-danger" style="margin-left: 5px;
    font-size: 12px;">Reject</span>
                  </span>  
                  </span>
                  <span style="cursor:pointer;">
                     <span data-toggle="tooltip" title="Give Feedback">
                    <span @click="rejectconfirmation(row.item,'Feedback')" class="badge badge-info" style="font-size: 12px; color:white;">Feedback</span>
                  </span>
                  </span>

                 

              </template>


          </b-table>
        <!-- </b-col> -->
      </b-col>
          <b-col md="6" class="my-1" >
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>

        <!-- Listing End -->
       
       <!-- Receipt Image Modal -->
         <b-modal v-model="receiptimage" @ok=" receiptimage= false"  title="Receipt Image" hide-footer>
                   <div class="d-block text-center" >
                      <img alt="This image is not available" style="width: 460px;height: 260px;" 
                      v-bind:src="receiptImgpath">  
                    </div>
                     <div>

                      <a :href="receiptImgpath" target="_blank"> <i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Download Recipt" style="color: ##20a8d8;float:right;margin-top:5px;margin-right: 5px;font-size:25px "></i></a> 
                    </div>
    
                </b-modal>

                  <!-- Receipt Image Modal End -->

           <b-modal size="md"  v-model="approveconfirmationmodal"  title="Review" hide-footer>
                <p class="my-4" hide-footer><strong>The Deposited Amount is&nbsp;</strong> <b style="color:red;font-size:18px">{{conformation}}</b><strong>.&nbsp; Are you Really Want to Approve?</strong></p>
                 <div class="col-md-12 mb-4 text-center">
                    <b-button  variant="danger" style="float: right;" @click="conformationcancel()" >
                              Cancel
                    </b-button>
                    <button   @click="approveBill()" class="btn btn-success"  style="float: right;margin-right:10px;">
                                    Yes
                    </button>

                            </div>
               
            </b-modal>

                    <!-- Model for Reject -->
        <b-modal hide-footer :title="rejectFeedbackstatus=='Reject'?'Give Reject Reason':'Give Feedback'" size="md" v-model="rejectconfirmationmodal" @ok="rejectconfirmationmodal = false">
            
              <template slot="default" slot-scope="{ hide }">
                <form @submit.prevent="validateForm5('form-4')" data-vv-scope="form-4">
                  <div class="modal-background"></div>
                  <div class="modal-card">
                    <section class="modal-card-body">  
                    <div >
                        <b-form-group>
                            <b-form-input style="height:60px" type="text" name="Reject" v-model="Rejecttext" v-validate="'required|min:5|max:30'" :class="{'input': true, 'text-danger': errors.has('form-4.Reject') }" placeholder="">                       
                            </b-form-input>
                            <b-input-group class="mb-3" >
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning" v-show="errors.has('Reject')" ></i>
                            </span>
                            <span style="width:240px" v-show="errors.has('form-4.Reject')" class="help text-danger">{{ errors.first('form-4.Reject') }}</span>
                            </b-input-group>
                            </b-form-group>
                        
                      </div>
                    </section>
                    <footer class="text-right">
                        <b-button style="margin-top: 10px;" size="sm"  variant="primary" type="submit" class="mr-4">Submit</b-button>
                      <b-button size="sm" variant="danger" @click="rejectcancel" style="margin-top: 10px;
                        margin-right: 24px;" >
                          Cancel
                      </b-button>
                  
                    </footer>
                  </div>
                </form>
              </template>
        </b-modal>
       <!-- Model for Reject End-->

        </b-card>
      </b-col>
    </b-row>
  </div>
</cdmpending-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';

export default {
  data: function() {
    return {
      
      pendingitems:[],
      fields:[
            { key: 'rider_name', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
        { key: 'deposite_amount', label: 'Deposited Amount', sortable: true, sortDirection: 'desc' },
          { key: 'wallet_amount', label: 'Wallet Amount', sortable: true, sortDirection: 'desc' },
          { key: 'pendingcodcollectable', label: 'Pending Amount', sortable: true, sortDirection: 'desc' },
        { key: 'requested_date', label: 'Requested Date', sortable: true, sortDirection: 'desc' },
         { key: 'transaction_type', label: 'Transaction Type', sortable: true, sortDirection: 'desc' },
         { key: 'receiptno', label: 'Receipt No', sortable: true, sortDirection: 'desc' },
        
          { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc' },
          { key: 'bill_type', label: 'Bill Type', sortable: true, sortDirection: 'desc' },
           { key: 'actions', label: 'Actions', sortable: true, sortDirection: 'desc' },
        ],
        selected:'',
        isBusy: false,
        
        Pickup:'',
        email:'',

        selectDateFrom:new Date(),
        selectDateTo:new Date(),
        bordered: true,
        
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        agentmaster:[],
        selected_agent:'Selected',
        deliveryagentid:'',
        totalRows:0,
         receiptimage:false,
         receiptImgpath:'',
         approveconfirmationmodal:false,
         conformation:'',
          agentid:'',
          approved:'',
          receipt:'',
          walletamount:'',
          requestid:'',
          rejectconfirmationmodal:false,
          Rejecttext:'',
          rejectFeedbackstatus:'',
        
    };
  },
   



  computed: {
    sortOptions() {
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.displaydata();
    this.cdmPendinglist();
  },
  methods: { 
  // Function for DeliveryAgent dropdown
  

downloadCSV: function(status) {
  // alert("status");
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
       var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid.key:"";
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      this.selected_status=status;
      
          const csvObj = {
          deliveryagentmasterid:deliveryagentid,
          fromdate:fromdate,
          todate:formatdateto,
          status: 'Pending',
          created_by:`${userInfo.sysemailid}`,
          sysusermasterid:`${userInfo.sysusermasterid}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
          is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
          };
          console.log("csvobj",csvObj);
          // return false;
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcdmdepositedetailscsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         // alert("Please Check Your Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
          this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }
        
        });
        
    },
     displaydata: function () {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentfirstname+ ' '+srData.deliveryagentlastname + '-'+srData.deliveryagentmasterid,
            });
          });
          this.agentmaster = data;   
          
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    // end
    // Pending Petrol Bill Listing
   cdmPendinglist:function(){
           
       var userdata = localStorage.getItem("userData");
       var userInfo = JSON.parse(userdata);
      console.log("this.deliveryagentid",typeof this.deliveryagentid);
        var deliveryagentid=(this.deliveryagentid!='')? this.deliveryagentid.key:null;
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      // this.selected_status=status;
      if(formatdateto< fromdate){
           // alert('To date need to be grater than From date');  
           this.$fire({
                  text:"To date need to be greater than From date",
                  type: "warning",
                  timer: 30000
                });     
             return false;
        }
     
      this.isBusy = true;
         
     
      const obj = {
    
        deliveryagentmasterid:deliveryagentid,
        fromdate:fromdate,
        todate:formatdateto,
        status: 'Pending',
        
         created_by:`${userInfo.sysemailid}`,
         hub_id:`${userInfo.pickuplocationmasterid}`,
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
       
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getcdmdepositedetails`,obj)
        .then(result => {
          this.isBusy=false;
          if (result.data.returnmsg == "Successful") {

            this.pendingitems  = result.body.returnvalue;
            this.imgpath=result.body.returnvalue;
           
            this.totalRows = result.body.returnvalue.length
          
          } else {
             this.pendingitems=[];
              this.imgpath=[];
             this.totalRows=0;
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });

   },
  // Pending Petrol Bill Listing End

  // Receipt Image modal Function

  reciptImagemodal(value) {
        // this.$refs['my-modal'].show();
        this.receiptimage=true;
        this.receiptImgpath=value.receipturl;
        console.log("urllll", this.receiptImgpath);

      },

      // Approve Bill Function
       approveconfirmation:function(approvevalue){
        console.log("approvevalue",approvevalue)
      this.conformation=approvevalue.deposite_amount;
       this.agentid=approvevalue.deliveryagentmasterid;
       
        this.approved=approvevalue.approveddby;
        this.receipt=approvevalue.receiptno;
        this.walletamount=approvevalue.wallet_amount;
        this.requestid=approvevalue.id;
        this.approveconfirmationmodal=true;
     
     
    },
    conformationcancel:function(){
      this.approveconfirmationmodal=false;
    },
     approveBill:function(){
         document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

        if( this.receipt=='undefined'||this.receipt==null){
          this.receipt='';
        }
        var approveObj = {
        deliveryagentmasterid: this.agentid,
        depositamount:this.conformation,
        wallet_amount:this.walletamount,
        created_by:`${userInfo.sysemailid}`,
        receipt_no: this.receipt,
        requestid: this.requestid,
      };

      console.log("Tesyyy",approveObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/approvecdmrequest`,
            approveObj
          )
          .then(result => {
          document.getElementById("overlay").style.display = "none";
           if(result.body.returnmsg === 'Successful') {
            this.$fire({
                  text:result.body.returnvalue,
                  type: "success",
                  timer: 30000
                }); 
            this.approveconfirmationmodal=false;
            this.cdmPendinglist();
            
      }else{
        this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
          })
          .catch(ex => {
            console.log("error", ex);
          });
     
     },
     
     // Approve Bill Function End
      

      // Reject Bill Function
      rejectconfirmation:function(value,status){
        this.rejectFeedbackstatus=status;
       this.agentid=value.deliveryagentmasterid;
       
        this.approved=value.approveddby;
        this.receipt=value.receiptno;
        this.walletamount=value.wallet_amount;
        this.requestid=value.id;
         this.rejectconfirmationmodal=true;
      },
      validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.rejectbill();
          }
      });
    },
     rejectbill:function(){
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

        if( this.receipt=='undefined'||this.receipt==null){
          this.receipt='';
        }
        var rejectObj = {
        // deliveryagentmasterid: this.agentid,
        // status:this.rejectFeedbackstatus,
        // created_by:`${userInfo.sysemailid}`,
        // feedback:this.Rejecttext,
        // id: this.requestid,
         deliveryagentmasterid:this.agentid,
        status: this.rejectFeedbackstatus,
        feedback:this.Rejecttext,
        // created_by:`${userInfo.sysusermasterid}`,
        created_by:`${userInfo.sysemailid}`,
        id:this.requestid,
      };

      console.log("Tesyyy",rejectObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/updatecdmdepositedetails`,
            rejectObj
          )
          .then(result => {
          document.getElementById("overlay").style.display = "none";
           if(result.body.returnmsg === 'Successful') {
            this.$fire({
                  text:this.rejectFeedbackstatus=='Reject'?'Rejected Successfully':'Feedback Sent Successfully',
                  type: "success",
                  timer: 30000
                }); 
            this.rejectconfirmationmodal=false;
            this.cdmPendinglist();
            
      }else{
        this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
          })
          .catch(ex => {
            console.log("error", ex);
          });
     },
     rejectcancel:function(){
     this.rejectconfirmationmodal=false;
     },
   
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    }, 
   
    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.deliveryagentid = '';
          this.displaydata();
          this.cdmPendinglist();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
  }
};
</script>

<style lang="css">

</style>
